module.exports = __webpack_public_path__ + "static/media/mina_loy_1.9d26fb08.png";